import { SubsAndPlansActionTypes } from './constants';

type SubPlanList = {
    limit: number;
    page: number;
    search: string;
    billing_cycle: string;
    is_active?: boolean;
};

type SubPlanListSuccess = {
    totalPages: number;
    page: number;
    plans: SubPlanListData[];
};

type SubPlanListData = {
    plan_id: string;
    plan_name: string;
    description: string;
    price: string;
    billing_cycle: string;
    max_users: string;
    max_outlets: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
};

type SubPlanDelete = {
    plan_id: string;
};

type SubPlanCreate = {
    plan_name: string;
    description: string;
    price: string;
    billing_cycle: string;
    is_active: boolean;
    modules: string[];
};

type SubPlanUpdate = {
    plan_id: string;
    plan_name?: string;
    description?: string;
    price?: string;
    billing_cycle?: string;
    max_users?: string;
    max_outlets?: string;
    is_active?: boolean;
};

type SubAdd = {
    business_id: string;
    outlet_id: string;
    plan_id: string;
    status: string;
    start_date: string;
    end_date: string;
};

type SubList = {
    business_id: string;
    outlet_id?: string;
};

type SubUpdateStatus = {
    plan_id: string;
    is_active: boolean;
};

export type SubsAndPlansAction =
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST; payload: SubPlanList }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST_SUCCESS; payload: SubPlanListSuccess }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE; payload: SubPlanDelete }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD; payload: SubPlanCreate }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE; payload: SubPlanUpdate }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD; payload: SubAdd }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_LIST; payload: SubList }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_LIST_SUCCESS; payload: any }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_LIST_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS; payload: SubUpdateStatus }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE; payload: any }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE_SUCCESS; payload: any }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES; payload: any }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES_SUCCESS; payload: { message: string } }
    | { type: typeof SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES_ERROR; payload: { error: string } }
    | { type: typeof SubsAndPlansActionTypes.RESET_SUB_SUCCESS };

export const subPlanList = (data: SubPlanList): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST,
    payload: data,
});

export const subPlanListSuccess = (data: SubPlanListSuccess): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST_SUCCESS,
    payload: data, // ✅ fixed (was `plans`)
});

export const subPlanListError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_LIST_ERROR,
    payload: { error },
});

export const subPlanAdd = (data: SubPlanCreate): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD,
    payload: data,
});
export const subPlanAddSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD_SUCCESS,
    payload: { message },
});
export const subPlanAddError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_ADD_ERROR,
    payload: { error },
});

export const subPlanDelete = (plan_id: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE,
    payload: { plan_id },
});
export const subPlanDeleteSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE_SUCCESS,
    payload: { message },
});
export const subPlanDeleteError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_DELETE_ERROR,
    payload: { error },
});

export const subPlanUpdate = (data: SubPlanUpdate): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE,
    payload: data,
});
export const subPlanUpdateSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_SUCCESS,
    payload: { message },
});
export const subPlanUpdateError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_ERROR,
    payload: { error },
});

export const subAdd = (data: any): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD,
    payload: data,
});
export const subAddSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD_SUCCESS,
    payload: { message },
});
export const subAddError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD_ERROR,
    payload: { error },
});

export const subList = (data: SubList): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_LIST,
    payload: data,
});
export const subListSuccess = (data: any): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_LIST_SUCCESS,
    payload: data,
});
export const subListError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_LIST_ERROR,
    payload: { error },
});

export const subPlanUpdateStatus = (data: SubUpdateStatus): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS,
    payload: data,
});
export const subPlanUpdateStatusSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS_SUCCESS,
    payload: { message },
});
export const subPlanUpdateStatusError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_PLAN_UPDATE_STATUS_ERROR,
    payload: { error },
});

export const subSchedule = (data: any): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE,
    payload: data,
});
export const subScheduleSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE_SUCCESS,
    payload: { message },
});
export const subScheduleError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_SCHEDULE_ERROR,
    payload: { error },
});

export const subAddModules = (data: any): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES,
    payload: data,
});
export const subAddModulesSuccess = (message: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES_SUCCESS,
    payload: { message },
});
export const subAddModulesError = (error: string): SubsAndPlansAction => ({
    type: SubsAndPlansActionTypes.SUBSCRIPTION_ADD_MODULES_ERROR,
    payload: { error },
});
export const resetSubSuccess = () => ({
    type: SubsAndPlansActionTypes.RESET_SUB_SUCCESS,
});
